import { render, staticRenderFns } from "./SourcewiseRoiReport.vue?vue&type=template&id=5d49c637"
import script from "./SourcewiseRoiReport.vue?vue&type=script&lang=js"
export * from "./SourcewiseRoiReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports